module.exports = __webpack_public_path__ + "static/media/track-zoutelande.406e3ac9.png";